import { State } from "../types/store";

export const selectForms = (state: State) => state.forms;
export const selectCurrentForm = (state: State) => state.forms.current;
export const selectFormIsLoading = (state: State) => state.forms.isLoading;
export const selectFonts = (state: State) => state.forms.fonts;
export const selectFormStyles = (state: State) => state.forms.styles;
export const selectStylesBackground = (state: State) => state.forms.styles.background;
export const selectPageStyles = (state: State) => state.forms.styles.page;
export const selectFormOwner = (state: State) => state.forms.ownerId;
export const selectTransferData = (state: State) => state.forms.transfer;
export const selectIsTransfering = (state : State) => state.forms.isTransfering;
